var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 11339",
    clipPath: "url(#clip0_14_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6112 5.03802H18.6682V1.42286C17.6723 1.31526 16.6715 1.26213 15.6702 1.26371C12.6941 1.26371 10.6589 3.15086 10.6589 6.60686V9.58538H7.2998V13.6325H10.6589V24.0005H14.6854V13.6325H18.0336L18.5369 9.58538H14.6854V7.00475C14.6854 5.81107 14.9918 5.03802 16.6112 5.03802Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_8548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.983398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayFbIcon);
export default __webpack_public_path__ + "static/media/gray_fb_icon.0e26af967b0dbf59b7c57d08fe9dcae7.svg";
export { ForwardRef as ReactComponent };